import CryptoJS from "crypto-js";

export default {
  install(Vue) {
    Vue.prototype.$alertModal = function (message, type) {
      this.$store.commit("AlertControl/SET_MESSAGE", message);
      this.$store.commit("AlertControl/SET_ALERTTYPE", type);
      this.$store.commit("AlertControl/SET_SHOWALERT", true);
      this.$store.commit("AlertControl/SET_CONFIRM", false);
    };

    Vue.prototype.$logout = function () {
      localStorage.clear("vuex");
      this.$store.commit("SignData/SET_INIT");
      this.$store.commit("UserInput/SET_INIT");
      this.$store.commit("ProductInfo/SET_INIT");
    };
    //이메일 정규식
    Vue.prototype.$emailValidation = function (data) {
      var regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
      if (regExp.test(data)) {
        //통과
        return true;
      } else {
        //올바르지 않음
        return false;
      }
    };
  },
};

export function popupCertification(url, strPopupName) {
  const settings = {
    width: 480,
    height: 820,
    status: "no",
    scrollbars: "yes",
    toolbar: "no",
    menubar: "no",
    location: "no",
    resizable: "no",
    fullscreen: "no",
    channelmode: "no",
    top: 0,
    left: 0,
  };

  const params =
    "width=" +
    settings.width +
    ", height=" +
    settings.height +
    ", status=" +
    settings.status +
    ", scrollbars=" +
    settings.scrollbars +
    ", toolbar=" +
    settings.toolbar +
    ", menubar=" +
    settings.menubar +
    ", location=" +
    settings.location +
    ", resizable=" +
    settings.resizable +
    ", fullscreen=" +
    settings.fullscreen +
    ", channelmode=" +
    settings.channelmode +
    ", top=" +
    settings.top +
    ", left=" +
    settings.left;

  const popup = window.open(url, strPopupName, params);
  popup.focus();

  return popup;
}

export function decrypt(cipherText) {
  const key = CryptoJS.enc.Utf8.parse("91b28f0ee88dee07d9e764495be14206");
  const iv = CryptoJS.enc.Utf8.parse("5edaee0a84dafa756689b09a1096d1b5");
  try {
    const decrypted = CryptoJS.AES.decrypt(
      cipherText,
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error("복호화 오류:", err);
    return null;
  }
}
